var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingBagLtr = function SvgShoppingBagLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 2c6.627 0 12 5.463 12 12.202v10.562h18.44A3.563 3.563 0 0 1 92 28.33v66.104A3.563 3.563 0 0 1 88.44 98H11.56A3.563 3.563 0 0 1 8 94.434V28.33a3.563 3.563 0 0 1 3.56-3.566h18.439V14.202C29.999 7.463 35.373 2 42 2zM13.22 92.77h73.56V29.994H70v12.92c0 1.453-1.16 2.63-2.589 2.63s-2.588-1.178-2.588-2.63v-12.92H35.176v12.92c0 1.453-1.159 2.63-2.588 2.63s-2.589-1.177-2.589-2.63v-12.92h-16.78zM42 7.263c-3.768 0-6.824 3.106-6.824 6.938v10.562h29.647V14.202c0-3.832-3.055-6.938-6.823-6.938z"
  })));
};
export default SvgShoppingBagLtr;